var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _g, _path97, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 594,
    viewBox: "0 0 515 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_5394)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.101 497.759L393.587 495.143L319.555 537.884L291.941 521.819L364.353 480.008L362.839 477.384L288.922 520.067L261.317 503.994L333.605 462.256L332.091 459.632L258.298 502.242L230.684 486.177L302.857 444.505L301.343 441.881L227.665 484.417L200.059 468.352L272.109 426.754L270.595 424.13L197.04 466.6L197.024 466.591L189.588 470.186L249.085 504.94L163.422 554.393L171.014 558.745L256.611 509.332L315.87 543.947L322.673 539.702L322.566 539.636L395.101 497.759Z",
    fill: "url(#paint0_linear_272_5394)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M435.131 539.584L436.342 537.49L495.587 571.606L517.685 558.783L459.737 525.408L460.948 523.32L520.101 557.384L542.193 544.561L484.344 511.239L485.555 509.151L544.609 543.156L566.707 530.333L508.943 497.07L510.161 494.975L569.116 528.934L591.215 516.104L533.55 482.9L534.768 480.806L593.631 514.706L593.644 514.699L599.588 517.568L551.975 545.31L620.534 584.791L614.452 588.264L545.958 548.816L498.536 576.445L493.092 573.057L493.171 573.011L435.131 539.584Z",
    fill: "url(#paint1_linear_272_5394)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5218 376.544L420.543 589.789C429.83 595.169 444.447 595.432 453.142 590.389L629.223 488.176C637.901 483.142 637.407 474.677 628.137 469.306L260.609 256.349C251.339 250.977 236.722 250.681 228.027 255.707L51.4854 357.658C42.7743 362.692 43.2431 371.164 52.5218 376.544Z",
    fill: "url(#paint2_linear_272_5394)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.436 387.386L404.659 554.385C418.273 562.274 439.651 562.669 452.385 555.266L590.257 475.212C602.974 467.826 602.25 455.462 588.661 447.59L300.883 280.845C287.294 272.973 265.931 272.546 253.181 279.908L114.922 359.731C102.148 367.109 102.822 379.497 116.436 387.386Z",
    fill: "#073036"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.784 328.546L253.181 254.161C265.931 246.799 287.294 247.226 300.883 255.098L599.116 418.158C599.116 418.158 599.355 431.311 599.347 436.534C599.339 441.297 596.328 445.953 590.257 449.474L452.385 529.527C439.643 536.922 418.273 536.527 404.651 528.647L116.436 361.639C109.633 357.699 106.055 352.631 105.784 347.63V328.546Z",
    fill: "#3C9A74"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.436 343.69L404.659 510.69C418.273 518.578 439.651 518.973 452.385 511.57L590.257 431.517C602.974 424.13 602.25 411.767 588.661 403.894L300.883 237.158C287.294 229.286 265.931 228.858 253.181 236.22L114.922 316.043C102.148 323.422 102.822 335.81 116.436 343.698V343.69ZM127.204 337.471C119.932 333.26 119.57 326.622 126.389 322.681L264.64 242.85C271.451 238.918 282.901 239.149 290.156 243.352L577.96 410.113C585.223 414.317 585.601 420.946 578.807 424.887L440.918 504.932C434.115 508.88 422.665 508.674 415.394 504.463L127.195 337.471H127.204Z",
    fill: "#04756D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.195 337.471L415.394 504.463C422.665 508.674 434.116 508.88 440.918 504.931L578.807 424.886C585.601 420.938 585.215 414.316 577.96 410.113L290.156 243.352C282.893 239.148 271.451 238.918 264.64 242.85L126.389 322.681C119.57 326.621 119.932 333.259 127.204 337.471H127.195Z",
    fill: "url(#paint3_linear_272_5394)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.093 264.755L267.724 262.074L260.132 257.689L255.501 260.371L263.093 264.755Z",
    fill: "#93FFC4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.95 261.375L273.581 258.693L265.989 254.309L261.358 256.99L268.95 261.375Z",
    fill: "#93FFC4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M274.807 257.985L279.438 255.312L271.845 250.928L267.214 253.609L274.807 257.985Z",
    fill: "#93FFC4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M280.663 254.605L285.295 251.931L277.702 247.547L273.071 250.22L280.663 254.605Z",
    fill: "#93FFC4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.403 333.893L142.035 331.211L134.442 326.827L129.811 329.509L137.403 333.893Z",
    fill: "#93FFC4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.26 330.504L147.891 327.831L140.299 323.446L135.668 326.128L143.26 330.504Z",
    fill: "#93FFC4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149.117 327.123L153.748 324.45L146.156 320.065L141.525 322.739L149.117 327.123Z",
    fill: "#93FFC4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.974 323.742L159.605 321.069L152.012 316.685L147.381 319.358L154.974 323.742Z",
    fill: "#93FFC4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M267.519 394.311L262.888 391.638L255.295 396.022L259.926 398.695L267.519 394.311Z",
    fill: "#93FFC4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M261.662 390.93L257.031 388.257L249.438 392.641L254.07 395.315L261.662 390.93Z",
    fill: "#93FFC4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M255.805 387.549L251.174 384.876L243.582 389.26L248.213 391.934L255.805 387.549Z",
    fill: "#93FFC4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M249.949 384.168L245.317 381.495L237.725 385.879L242.356 388.553L249.949 384.168Z",
    fill: "#93FFC4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M343.665 382.993L339.034 380.319L331.441 384.704L336.072 387.377L343.665 382.993Z",
    fill: "#93FFC4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M337.808 379.611L333.177 376.93L325.584 381.314L330.216 383.996L337.808 379.611Z",
    fill: "#93FFC4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M331.951 376.23L327.32 373.549L319.728 377.933L324.359 380.615L331.951 376.23Z",
    fill: "#93FFC4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M326.095 372.851L321.463 370.169L313.871 374.553L318.502 377.235L326.095 372.851Z",
    fill: "#93FFC4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M378.633 430.768L373.993 428.095L366.401 432.479L371.04 435.152L378.633 430.768Z",
    fill: "#93FFC4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M372.776 427.387L368.136 424.714L360.544 429.098L365.183 431.772L372.776 427.387Z",
    fill: "#93FFC4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M366.919 424.006L362.28 421.333L354.687 425.717L359.327 428.391L366.919 424.006Z",
    fill: "#93FFC4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M361.062 420.626L356.423 417.952L348.831 422.337L353.47 425.01L361.062 420.626Z",
    fill: "#93FFC4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M382.836 460.89L378.197 458.217L370.604 462.601L375.244 465.275L382.836 460.89Z",
    fill: "#93FFC4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M376.979 457.51L372.34 454.837L364.747 459.221L369.387 461.895L376.979 457.51Z",
    fill: "#93FFC4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M371.122 454.129L366.483 451.456L358.891 455.832L363.53 458.514L371.122 454.129Z",
    fill: "#93FFC4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M365.266 450.748L360.626 448.066L353.034 452.451L357.673 455.132L365.266 450.748Z",
    fill: "#93FFC4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M526.59 392.238L521.95 389.564L514.358 393.949L518.997 396.622L526.59 392.238Z",
    fill: "#93FFC4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M261.572 261.243L370.9 324.36L364.764 327.905L271.039 273.796L217.629 304.634L352.072 382.253L411.618 347.869L419.12 352.204L336.344 399.987L382.573 426.68L465.957 378.535L475.762 384.194L359.804 451.152L359.162 450.781L474.496 384.194L465.957 379.267L382.573 427.412L335.077 399.987L417.845 352.204L411.618 348.609L352.072 382.985L216.354 304.634L271.039 273.055L364.764 327.173L369.625 324.36L260.938 261.613",
    fill: "#93FFC4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M267.691 257.714L383.124 324.359L364.764 334.962L271.039 280.853L229.853 304.634L352.071 375.194L411.618 340.811L431.343 352.203L348.575 399.987L382.573 419.622L465.957 371.476L487.986 384.193L365.915 454.68L365.274 454.31L486.719 384.193L465.957 372.208L382.573 420.354L347.3 399.987L430.076 352.203L411.618 341.543L352.071 375.926L228.578 304.634L271.039 280.113L364.764 334.23L381.849 324.359L267.05 258.084",
    fill: "#93FFC4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M273.803 254.186L395.347 324.36L364.764 342.02L271.039 287.911L242.076 304.634L352.071 368.137L411.618 333.753L443.567 352.204L360.799 399.987L382.573 412.565L465.957 364.419L500.218 384.194L372.027 458.209L371.394 457.839L498.943 384.194L465.957 365.151L382.573 413.297L359.524 399.987L442.3 352.204L411.618 334.486L352.071 368.869L240.81 304.634L271.039 287.171L364.764 341.288L394.08 324.36L273.162 254.556",
    fill: "#93FFC4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M279.915 250.656L407.571 324.359L364.764 349.078L271.039 294.969L254.3 304.634L352.072 361.079L411.618 326.695L455.79 352.203L373.023 399.987L382.573 405.506L465.957 357.361L512.441 384.193L378.139 461.738L377.506 461.368L511.166 384.193L465.957 358.093L382.573 406.239L371.748 399.987L454.524 352.203L411.618 327.427L352.072 361.811L253.033 304.634L271.039 294.228L364.764 348.346L406.304 324.359L279.273 251.026",
    fill: "#93FFC4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M263.249 394.146L311.378 366.352L269.23 342.02L229.952 364.698L222.302 360.281L261.58 337.603L211.271 308.557L171.993 331.236L156.175 322.097L156.808 321.735L171.993 330.504L211.271 307.825L262.846 337.603L223.568 360.281L229.952 363.966L269.23 341.288L312.653 366.352L263.891 394.508",
    fill: "#93FFC4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M257.138 390.618L299.155 366.352L269.23 349.077L229.952 371.756L210.07 360.281L249.348 337.602L211.271 315.615L171.993 338.293L150.063 325.626L150.696 325.264L171.993 337.561L211.271 314.883L250.623 337.602L211.345 360.281L229.952 371.024L269.23 348.345L300.43 366.352L257.771 390.979",
    fill: "#93FFC4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M251.026 387.089L286.932 366.351L269.23 356.135L229.952 378.813L197.846 360.281L237.124 337.602L211.271 322.673L171.993 345.351L143.943 329.154L144.584 328.793L171.993 344.619L211.271 321.94L238.399 337.602L199.121 360.281L229.952 378.081L269.23 355.403L288.198 366.351L251.659 387.451",
    fill: "#93FFC4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M244.914 383.56L274.708 366.36L269.23 363.193L229.952 385.871L185.623 360.281L224.901 337.602L211.271 329.73L171.993 352.409L137.831 332.683L138.473 332.321L171.993 351.677L211.271 328.998L226.176 337.602L186.898 360.281L229.952 385.139L269.23 362.461L275.975 366.36L245.548 383.922",
    fill: "#93FFC4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M523.891 391.046L376.436 476.182L421.3 502.085L568.763 416.948L569.396 417.319L421.3 502.817L375.161 476.182L523.258 390.684",
    fill: "#93FFC4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M530.003 394.575L388.66 476.183L421.3 495.028L562.651 413.42L563.285 413.79L421.3 495.76L387.385 476.183L529.37 394.213",
    fill: "#93FFC4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M536.115 398.103L400.883 476.182L421.3 487.97L556.54 409.891L557.173 410.261L421.3 488.702L399.608 476.182L535.481 397.741",
    fill: "#93FFC4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M542.227 401.632L413.107 476.183L421.299 480.912L550.428 406.362L551.061 406.732L421.299 481.645L411.84 476.183L541.593 401.271",
    fill: "#93FFC4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M320.542 373.565L264.13 406.131L340.695 450.337L370.974 432.857L371.608 433.219L340.695 451.069L262.863 406.131L319.909 373.195",
    fill: "#93FFC4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M326.654 377.095L276.353 406.132L340.695 443.279L364.863 429.328L365.496 429.69L340.695 444.011L275.086 406.132L326.02 376.725",
    fill: "#93FFC4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M332.766 380.623L288.577 406.131L340.695 436.221L358.751 425.799L359.384 426.161L340.695 436.953L287.31 406.131L332.132 380.253",
    fill: "#93FFC4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M338.877 384.152L300.8 406.132L340.695 429.164L352.639 422.271L353.272 422.633L340.695 429.896L299.533 406.132L338.244 383.782",
    fill: "#93FFC4"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M189.835 302.569L229.828 279.471C235.603 276.131 235.298 270.53 229.129 266.96L226.012 265.158L165.083 300.34L168.201 302.15C174.37 305.72 184.052 305.909 189.835 302.569Z",
    fill: "#04756D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M425.141 483.463L444.603 481.423C446.248 481.25 447.778 482.114 447.523 483.076L444.422 494.6C444.134 495.678 441.848 496.048 440.449 495.242L424.088 485.758C422.715 484.96 423.315 483.652 425.141 483.463Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M478.329 463.769C483.709 466.887 492.148 467.043 497.174 464.123C502.208 461.203 501.92 456.309 496.549 453.191C491.169 450.074 482.738 449.917 477.704 452.837C472.67 455.758 472.949 460.652 478.329 463.769Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_272_5394)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M167.058 594.494C187.542 594.494 204.148 577.889 204.148 557.404C204.148 536.92 187.542 520.314 167.058 520.314C146.573 520.314 129.968 536.92 129.968 557.404C129.968 577.889 146.573 594.494 167.058 594.494Z",
    fill: "url(#paint4_radial_272_5394)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_272_5394)"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M217.16 252.91L285.064 292.122V213.706L217.16 174.502V252.91Z",
    fill: "url(#paint5_linear_272_5394)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M222.302 249.94L279.923 283.205V216.675L222.302 183.418V249.94Z",
    stroke: "url(#paint6_linear_272_5394)",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M352.968 174.502L285.064 213.706V292.122L352.968 252.91V174.502Z",
    fill: "url(#paint7_linear_272_5394)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M348.362 182.489L289.679 216.371V284.135L348.362 250.253V182.489Z",
    stroke: "url(#paint8_linear_272_5394)",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M285.064 134.524L217.16 174.502L285.064 213.706L352.968 174.502L285.064 134.524Z",
    fill: "url(#paint9_linear_272_5394)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M310.72 253.848L318.535 238.927L323.084 244.101L321.134 247.835L310.72 253.848Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M336.747 218L328.941 232.922L328.077 234.575L327.205 233.917L327.772 235.151L326.769 237.059L325.905 238.721L322.87 236.426L325.379 239.724L324.606 241.205L323.734 242.867L318.535 238.926L326.341 224.013L336.747 218Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M328.077 243.829L326.341 244.833L323.734 242.867L318.535 238.926L320.262 237.923L324.606 241.205L328.077 243.829Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M332.412 241.328L330.676 242.323L328.077 240.357L325.905 238.72L322.87 236.425L324.606 235.422L326.769 237.059L332.412 241.328Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M336.747 238.82L335.011 239.823L332.412 237.857L328.077 234.575L327.205 233.917L328.94 232.922L336.747 238.82Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M321.998 221.315L311.592 227.32L303.786 242.242L310.071 238.606L306.385 255.485L321.998 225.65L318.749 227.526L321.998 221.315Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M239.14 241.936L247.431 235.865L252.268 247.061L250.195 248.582L239.14 241.936Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M266.778 236.434L258.487 242.504L257.565 243.179L256.644 241.402L257.245 243.417L256.183 244.199L255.262 244.873L252.038 238.63L254.703 245.276L253.88 245.885L252.959 246.559L247.431 235.866L255.723 229.787L266.778 236.434Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M257.565 253.008L255.723 251.905L252.959 246.559L247.431 235.865L249.274 236.967L253.88 245.884L257.565 253.008Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M262.172 255.78L260.329 254.669L257.565 249.322L255.262 244.872L252.038 238.629L253.88 239.739L256.183 244.198L262.172 255.78Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M266.778 258.544L264.936 257.442L262.172 252.095L257.565 243.178L256.644 241.401L258.487 242.504L266.778 258.544Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M251.116 221.495L240.061 214.849L231.769 220.927L238.449 224.942L234.533 238.251L251.116 226.101L247.661 224.029L251.116 221.495Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_272_5394)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M285.188 200.66C300.043 200.66 312.086 188.617 312.086 173.762C312.086 158.906 300.043 146.863 285.188 146.863C270.332 146.863 258.289 158.906 258.289 173.762C258.289 188.617 270.332 200.66 285.188 200.66Z",
    fill: "url(#paint10_radial_272_5394)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_272_5394)"
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M412.111 188.462L507.942 243.927V133.009L412.111 77.5557V188.462Z",
    fill: "url(#paint11_linear_272_5394)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M419.367 184.262L500.686 231.314V137.209L419.367 90.168V184.262Z",
    stroke: "url(#paint12_linear_272_5394)",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M603.772 77.5557L507.942 133.009V243.927L603.772 188.462V77.5557Z",
    fill: "url(#paint13_linear_272_5394)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M597.271 88.8535L514.454 136.779V232.629L597.271 184.704V88.8535Z",
    stroke: "url(#paint14_linear_272_5394)",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M507.942 21.0088L412.111 77.5558L507.942 133.009L603.772 77.5558L507.942 21.0088Z",
    fill: "url(#paint15_linear_272_5394)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M443.13 172.94L454.832 164.354L461.657 180.189L458.732 182.342L443.13 172.94Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M482.135 165.157L470.434 173.744L469.134 174.698L467.833 172.185L468.681 175.035L467.183 176.141L465.883 177.095L461.332 168.264L465.094 177.665L463.933 178.526L462.633 179.48L454.832 164.354L466.533 155.756L482.135 165.157Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M469.134 188.601L466.533 187.042L462.633 179.479L454.832 164.354L457.432 165.913L463.933 178.525L469.134 188.601Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M475.635 192.523L473.034 190.952L469.134 183.389L465.883 177.095L461.333 168.264L463.933 169.834L467.183 176.141L475.635 192.523Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M482.135 196.432L479.535 194.873L475.635 187.31L469.134 174.698L467.833 172.185L470.434 173.744L482.135 196.432Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M460.032 144.027L444.43 134.626L432.729 143.224L442.155 148.902L436.629 167.728L460.032 150.543L455.157 147.611L460.032 144.027Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_272_5394)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M508.929 98.6599C523.784 98.6599 535.827 86.6171 535.827 71.7616C535.827 56.9061 523.784 44.8633 508.929 44.8633C494.073 44.8633 482.031 56.9061 482.031 71.7616C482.031 86.6171 494.073 98.6599 508.929 98.6599Z",
    fill: "url(#paint16_radial_272_5394)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_272_5394)"
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 206.846L67.9038 246.058V167.642L0 128.438V206.846Z",
    fill: "url(#paint17_linear_272_5394)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14111 203.875L62.7627 237.14V170.61L5.14111 137.354V203.875Z",
    stroke: "url(#paint18_linear_272_5394)",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M135.808 128.438L67.9038 167.642V246.058L135.808 206.846V128.438Z",
    fill: "url(#paint19_linear_272_5394)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M131.201 136.425L72.5186 170.307V238.071L131.201 204.189V136.425Z",
    stroke: "url(#paint20_linear_272_5394)",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9038 88.46L0 128.437L67.9038 167.641L135.808 128.437L67.9038 88.46Z",
    fill: "url(#paint21_linear_272_5394)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5601 207.784L101.375 192.862L105.923 198.036L103.974 201.771L93.5601 207.784Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M119.586 171.936L111.78 186.857L110.916 188.51L110.044 187.852L110.612 189.086L109.609 190.995L108.745 192.656L105.709 190.361L108.218 193.66L107.445 195.14L106.573 196.802L101.375 192.862L109.181 177.949L119.586 171.936Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M110.916 197.765L109.181 198.768L106.573 196.802L101.375 192.862L103.102 191.858L107.445 195.14L110.916 197.765Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M115.251 195.264L113.516 196.259L110.916 194.293L108.745 192.656L105.709 190.361L107.445 189.357L109.608 190.994L115.251 195.264Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M119.586 192.755L117.851 193.759L115.251 191.793L110.916 188.511L110.044 187.853L111.78 186.857L119.586 192.755Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M104.838 175.251L94.432 181.256L86.6257 196.177L92.9102 192.542L89.2251 209.421L104.838 179.586L101.588 181.461L104.838 175.251Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9792 195.871L30.2708 189.801L35.1076 200.996L33.0347 202.518L21.9792 195.871Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6178 190.369L41.3262 196.44L40.4049 197.114L39.4836 195.337L40.0841 197.353L39.023 198.134L38.1017 198.809L34.8772 192.565L37.5423 199.212L36.7198 199.821L35.7985 200.495L30.2708 189.802L38.5623 183.723L49.6178 190.369Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4049 206.943L38.5623 205.841L35.7985 200.494L30.2708 189.801L32.1133 190.903L36.7198 199.82L40.4049 206.943Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0114 209.715L43.1688 208.605L40.4049 203.258L38.1017 198.808L34.8772 192.564L36.7198 193.675L39.023 198.133L45.0114 209.715Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6178 212.479L47.7752 211.377L45.0114 206.03L40.4049 197.114L39.4836 195.337L41.3262 196.439L49.6178 212.479Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9559 175.431L22.9005 168.784L14.6089 174.863L21.2882 178.877L17.3727 192.187L33.9559 180.037L30.5011 177.964L33.9559 175.431Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_272_5394)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M68.8497 152.128C83.7052 152.128 95.748 140.085 95.748 125.229C95.748 110.374 83.7052 98.3311 68.8497 98.3311C53.9942 98.3311 41.9514 110.374 41.9514 125.229C41.9514 140.085 53.9942 152.128 68.8497 152.128Z",
    fill: "url(#paint22_radial_272_5394)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_272_5394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1528 122.598C71.1528 122.598 106.564 -4.37278 200.317 33.4559C294.069 71.2847 287.354 171.52 287.354 171.52",
    stroke: "url(#paint23_linear_272_5394)",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M285.435 174.769C285.435 174.769 257.878 -15.0047 385.789 2.08913C464.756 12.6422 508.765 72.0084 508.765 72.0084",
    stroke: "url(#paint24_linear_272_5394)",
    strokeWidth: 1.06,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_5394",
    x1: 185.233,
    y1: 517.444,
    x2: 315.301,
    y2: 391.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_272_5394",
    x1: 452.586,
    y1: 555.295,
    x2: 556.422,
    y2: 454.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_272_5394",
    x1: 511.643,
    y1: 763.797,
    x2: 517.576,
    y2: 429.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B36F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BF8D0",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_272_5394",
    x1: 165.013,
    y1: 425.625,
    x2: 423.711,
    y2: 173.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_272_5394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.058 557.404) scale(37.09 37.09)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_272_5394",
    x1: 292.015,
    y1: 188.404,
    x2: 181.336,
    y2: 232.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.199334,
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_272_5394",
    x1: 265.724,
    y1: 259.31,
    x2: 236.51,
    y2: 207.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B36F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BF8D0",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_272_5394",
    x1: 301.475,
    y1: 272.306,
    x2: 402.578,
    y2: 218.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_272_5394",
    x1: 333.901,
    y1: 259.795,
    x2: 304.14,
    y2: 206.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B36F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BF8D0",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_272_5394",
    x1: 235.257,
    y1: 208.145,
    x2: 328.68,
    y2: 80.8064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_272_5394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.188 173.762) scale(26.8983 26.8983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_272_5394",
    x1: 517.751,
    y1: 97.2191,
    x2: 361.457,
    y2: 159.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.199334,
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_272_5394",
    x1: 480.647,
    y1: 197.516,
    x2: 439.276,
    y2: 124.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B36F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BF8D0",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_272_5394",
    x1: 531.101,
    y1: 215.898,
    x2: 673.927,
    y2: 140.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_272_5394",
    x1: 576.863,
    y1: 198.201,
    x2: 534.717,
    y2: 123.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B36F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BF8D0",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_272_5394",
    x1: 437.651,
    y1: 125.144,
    x2: 569.886,
    y2: -54.6874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_272_5394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(508.929 71.7616) scale(26.8983 26.8983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_272_5394",
    x1: 74.8546,
    y1: 142.339,
    x2: -35.824,
    y2: 186.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.199334,
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_272_5394",
    x1: 48.5632,
    y1: 213.245,
    x2: 19.3499,
    y2: 161.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B36F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BF8D0",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_272_5394",
    x1: 84.3142,
    y1: 226.242,
    x2: 185.418,
    y2: 172.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_272_5394",
    x1: 116.74,
    y1: 213.731,
    x2: 86.9795,
    y2: 160.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B36F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BF8D0",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_272_5394",
    x1: 18.0967,
    y1: 162.081,
    x2: 111.52,
    y2: 34.7419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_272_5394",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.8497 125.229) scale(26.8983 26.8983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_272_5394",
    x1: 234.156,
    y1: 136.774,
    x2: 213.488,
    y2: 41.7805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B36F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFB",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_272_5394",
    x1: 448.438,
    y1: 188.946,
    x2: 427.77,
    y2: 93.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B36F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFB",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_5394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 626.146,
    height: 389.556,
    fill: "white",
    transform: "translate(45.2419 204.444)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_272_5394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.1883,
    height: 74.1883,
    fill: "white",
    transform: "translate(129.968 520.314)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_272_5394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.808,
    height: 157.598,
    fill: "white",
    transform: "translate(217.16 134.524)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_272_5394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.7883,
    height: 53.7883,
    fill: "white",
    transform: "translate(258.289 146.863)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_272_5394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191.661,
    height: 222.919,
    fill: "white",
    transform: "translate(412.111 21.0088)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_272_5394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.7883,
    height: 53.7883,
    fill: "white",
    transform: "translate(482.031 44.8633)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_272_5394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.808,
    height: 157.598,
    fill: "white",
    transform: "translate(0 88.46)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_272_5394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.7883,
    height: 53.7883,
    fill: "white",
    transform: "translate(41.9514 98.3311)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_272_5394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218.806,
    height: 146.419,
    fill: "white",
    transform: "translate(69.0964 25.1221)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.37fea2ff0a6ded20d9c39da49e258b63.svg";
export { ForwardRef as ReactComponent };